import React from "react";
import { Box, Link, makeStyles, Typography } from "@material-ui/core";

import { useDispatch } from "react-redux";
const useStyles = makeStyles((theme) => ({
  link: {
    display: "flex",
    alignItems: "center",
    fontSize: "1.1em",
    marginBottom: 30,
  },
  h1: {
    fontSize: "2.5rem",
    marginBottom: "25px",
  },
  h2: {
    fontSize: "1.25rem",
    marginBottom: "50px",
    fontWeight: 300,
  },
  h3: {
    fontSize: "1.25rem",
    marginBottom: "25px",
    fontWeight: 400,
  },
  h33: {
    fontSize: "1.25rem",
    marginTop: "50px",
    marginBottom: "25px",
    fontWeight: 400,
  },
  option: {
    // paddingLeft: 25,
  },
  hr: {
    marginTop: 50,
  },
  box: {
    border: "2px solid #ddd",
    padding: 15,
    backgroundColor: "#eee",
  },
}));

const DefaultRenderer: React.FC<{ error: any }> = ({ error }) => {
  const dispatch = useDispatch();
  const classes = useStyles();
  return (
    <>
      <Typography className={classes.h1}>Something went wrong</Typography>

      <Typography className={classes.h2} variant="h2">
        It might be that the system is experiencing a temporary issue or 
        that you don't have permission to view the requested page.
      </Typography>

      <Typography className={classes.h3} variant="h3">
        What should I do next?
      </Typography>

      <p className={classes.option}>
        You can reload the current page using your browsers refresh button or by
        clicking this{" "}
        <Link href={window.location.href} className="linkButton">
          Refresh
        </Link>{" "}
        button.
      </p>
      <p className={classes.option}>
        If the problem persists you may want to log out and log back in to
        ensure you're using the correct account by clicking this{" "}
        <Link
          href={window.location.href}
          onClick={() => {
            dispatch({ type: "auth/LOGOUT" });
          }}
          className="linkButton"
        >
          Logout
        </Link>{" "}
        button.
      </p>

      <p className={classes.option}>
        If reloading the page or logging in does not resolve the issue you can
        contact Ofqual Portal Support for assistance, the information in the box
        below may help the support team resolve your issue more efficiently.
      </p>

      <Typography className={classes.h33} variant="h3">
        Detailed error information
      </Typography>

      <Box className={classes.box}>
        <code>{JSON.stringify(error, undefined, 2)}</code>
      </Box>
    </>
  );
};

export const defaultRenderer = (error: any) => (
  <DefaultRenderer error={error} />
);
